import ReduxHelper from 'lib/ReduxHelper';

export const PARTIES_ACTION_TYPES = {
  PARTIES_FETCH_DATA: 'PARTIES_FETCH_DATA',
  PARTIES_FETCH_DATA_SUCCESS: 'PARTIES_FETCH_DATA_SUCCESS',
  PARTIES_FETCH_DATA_FAIL: 'PARTIES_FETCH_DATA_FAIL',
  PARTIES_CLEAR_DATA: 'PARTIES_CLEAR_DATA',

  PARTY_CREATE: 'PARTY_CREATE',
  PARTY_CREATE_SUCCESS: 'PARTY_CREATE_SUCCESS',
  PARTY_CREATE_FAIL: 'PARTY_CREATE_FAIL',
  PARTY_CREATE_CLEAR: 'PARTY_CREATE_CLEAR',

  PARTY_FETCH: 'PARTY_FETCH',
  PARTY_FETCH_SUCCESS: 'PARTY_FETCH_SUCCESS',
  PARTY_FETCH_FAIL: 'PARTY_FETCH_FAIL',
  PARTY_CLEAR: 'PARTY_CLEAR',

  AUCTION_PARTY_FETCH: 'AUCTION_PARTY_FETCH',
  AUCTION_PARTY_FETCH_SUCCESS: 'AUCTION_PARTY_FETCH_SUCCESS',
  AUCTION_PARTY_FETCH_FAIL: 'AUCTION_PARTY_FETCH_FAIL',
  AUCTION_PARTY_CLEAR: 'AUCTION_PARTY_CLEAR',

  PARTY_UPDATE: 'PARTY_UPDATE',
  PARTY_UPDATE_SUCCESS: 'PARTY_UPDATE_SUCCESS',
  PARTY_UPDATE_FAIL: 'PARTY_UPDATE_FAIL',
  PARTY_UPDATE_CLEAR: 'PARTY_UPDATE_CLEAR',

  PARTY_DELETE: 'PARTY_DELETE',
  PARTY_DELETE_SUCCESS: 'PARTY_DELETE_SUCCESS',
  PARTY_DELETE_FAIL: 'PARTY_DELETE_FAIL',
  PARTY_DELETE_CLEAR: 'PARTY_DELETE_CLEAR',

  PARTY_ENABLE_DISABLE: 'PARTY_ENABLE_DISABLE',
  PARTY_ENABLE_DISABLE_SUCCESS: 'PARTY_ENABLE_DISABLE_SUCCESS',
  PARTY_ENABLE_DISABLE_FAIL: 'PARTY_ENABLE_DISABLE_FAIL',
  PARTY_ENABLE_DISABLE_CLEAR: 'PARTY_ENABLE_DISABLE_CLEAR',

  SET_PARTIES_GRID_FILTER: 'SET_PARTIES_GRID_FILTER',
  CLEAR_PARTIES_GRID_FILTER: 'CLEAR_PARTIES_GRID_FILTER',
};

export const fetchPartiesData = () =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.PARTIES_FETCH_DATA);

export const createParty = partyData =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.PARTY_CREATE, partyData);
export const clearCreateParty = () =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.PARTY_CREATE_CLEAR);
export const fetchParty = partyId =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.PARTY_FETCH, partyId);
export const updateParty = partyData =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.PARTY_UPDATE, partyData);
export const clearUpdateParty = () =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.PARTY_UPDATE_CLEAR);
export const deleteParty = partyId =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.PARTY_DELETE, partyId);
export const enableDisableParty = partyId =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.PARTY_ENABLE_DISABLE, partyId);

export const clearCurrentParty = () =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.PARTY_CLEAR);

export const setGridFilter = (filterName, filterValue) =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.SET_PARTIES_GRID_FILTER, {
    name: filterName,
    value: filterValue,
  });
export const clearGridFilter = () =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.CLEAR_PARTIES_GRID_FILTER);
export const fetchAuctionParty = (id, partyType) =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.AUCTION_PARTY_FETCH, {
    id,
    partyType,
  });
export const clearAuctionParty = partyType =>
  ReduxHelper.createAction(PARTIES_ACTION_TYPES.AUCTION_PARTY_CLEAR, partyType);
